import { render } from "./MatchModal.vue?vue&type=template&id=56317238&scoped=true"
import script from "./MatchModal.vue?vue&type=script&lang=js"
export * from "./MatchModal.vue?vue&type=script&lang=js"

import "./MatchModal.vue?vue&type=style&index=0&id=56317238&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56317238"]])

export default __exports__